import React from "react";
import { Trans } from "react-i18next";
import classnames from "classnames";
import s from "./PrettyDateBox.module.scss";
import i18n from "../../../i18n";
const PrettyDateBox = ({ messages, index, fixedDate }) => {
    const formatDateTime = (date) => {
        return new Intl.DateTimeFormat(i18n.language, {
            year: "numeric",
            month: "long",
            day: "numeric",
        }).format(date);
    };
    const isValidDate = (date) => !isNaN(date.getTime());
    const getPrettyDate = (messages, key) => {
        var _a, _b;
        const timestamp = (_a = messages[key]) === null || _a === void 0 ? void 0 : _a.timestamp;
        if (!timestamp)
            return null;
        if (key === 0) {
            const messageDate = new Date(timestamp);
            if (!isValidDate(messageDate))
                return null;
            return formatDateTime(messageDate);
        }
        else {
            const prevTimestamp = (_b = messages[key - 1]) === null || _b === void 0 ? void 0 : _b.timestamp;
            if (!prevTimestamp)
                return null;
            const previousDate = new Date(prevTimestamp);
            const pastDate = new Date(timestamp);
            const currentDate = new Date();
            if (!isValidDate(previousDate) || !isValidDate(pastDate))
                return null;
            const diffTime = Math.abs(currentDate.getTime() - previousDate.getTime());
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (diffDays < 7) {
                const weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                if (pastDate.getDay() === currentDate.getDay()) {
                    return React.createElement(Trans, { i18nKey: "Today" });
                }
                else
                    return React.createElement(Trans, { i18nKey: `${weekDays[pastDate.getDay()]}` });
            }
            else {
                return formatDateTime(pastDate);
            }
        }
    };
    return (React.createElement("div", { className: classnames(s.timestampBoxContainer, "date-label") },
        React.createElement("div", { className: s.timestampBox },
            React.createElement("p", { className: s.timeDiffText }, fixedDate || getPrettyDate(messages, index)))));
};
export default PrettyDateBox;
